module.exports = __webpack_public_path__ + "img/tooltip_litho-board-3.e0ef482d.jpg";